<template>
  <settings-modal
    class="profile-forex-currency-pair-editor-modal t-prifle-forex-currency-pair-editor-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >
      <span>{{ title }}</span>
      <forex-currency-pair-currencies
        v-if="modalData.currencyPair != null"
        class="red--text text--darken-2"
        :from="modalData.currencyPair.fromCurrency"
        :to="modalData.currencyPair.toCurrency"
        size="24"
      />
    </span>

    <v-layout
      v-if="modalData.currencyPair == null"
      row
    >
      <v-flex xs12>
        <v-select
          v-model="selectedCurrencyPair"
          class="pt-1"
          label="Currency pair"
          return-object
          :items="currencyPairs"
          :item-value="formatCurrencyPairSelectItemValue"
          :disabled="currencyPairsApiRequest.loading"
          :loading="currencyPairsApiRequest.loading"
          :error-messages="getValidationErrorMessage('fromCurrency')"
        >
          <template
            slot="item"
            slot-scope="data"
          >
            <forex-currency-pair-currencies
              :from="data.item.fromCurrency"
              :to="data.item.toCurrency"
              medium
            />
          </template>
          <template
            slot="selection"
            slot-scope="data"
          >
            <forex-currency-pair-currencies
              :from="data.item.fromCurrency"
              :to="data.item.toCurrency"
              medium
            />
          </template>
        </v-select>
      </v-flex>
    </v-layout>

    <template v-if="selectedCurrencyPair != null">
      <data-row style="margin-bottom: 17px;">
        <v-flex xs6>
          <one-data-column v-bind="oneDataFirstColumnProps">
            <data-label slot="label">Buy {{ selectedCurrencyPair.fromCurrency }}</data-label>
            <div class="t-buy-rate font-weight-medium">{{ selectedCurrencyPair.buy.rate | number }} {{ selectedCurrencyPair.toCurrency }}</div>
          </one-data-column>

          <one-data-column v-bind="oneDataFirstColumnProps">
            <data-label slot="label">Buy</data-label>
            <div class="t-buy">{{ formatBooleanValue(selectedCurrencyPair.buy.enabled) }}</div>
          </one-data-column>

          <one-data-column v-bind="oneDataFirstColumnProps">
            <data-label slot="label">Fees buy</data-label>
            <div class="t-buy-fees">{{ formatBooleanValue(selectedCurrencyPair.buy.fee) }}</div>
          </one-data-column>
        </v-flex>

        <v-flex xs6>
          <one-data-column v-bind="oneDataSecondColumnProps">
            <data-label slot="label">Sell {{ selectedCurrencyPair.fromCurrency }}</data-label>
            <div class="t-sell-rate font-weight-medium">{{ selectedCurrencyPair.sell.rate | number }} {{ selectedCurrencyPair.toCurrency }}</div>
          </one-data-column>

          <one-data-column v-bind="oneDataSecondColumnProps">
            <data-label slot="label">Sell</data-label>
            <div class="t-sell">{{ formatBooleanValue(selectedCurrencyPair.sell.enabled) }}</div>
          </one-data-column>

          <one-data-column v-bind="oneDataSecondColumnProps">
            <data-label slot="label">Fees sell</data-label>
            <div class="t-sell-fees">{{ formatBooleanValue(selectedCurrencyPair.sell.fee) }}</div>
          </one-data-column>
        </v-flex>
      </data-row>

      <data-heading
        heading="Period of activity"
        spaced
      />

      <v-layout row>
        <v-flex xs6>
          <v-checkbox
            v-model="form.buyDayMarginEnabled"
            :ripple="false"
            label="Day buy"
            color="primary"
            hide-details
            disabled
            @change="onPeriodMarginCheckboxChange($event, 'buyDayMargin')"
          />
          <v-text-field
            v-model="form.buyDayMargin"
            class="forex-currency-pair-add-modal__margin-field"
            type="number"
            label="Margin"
            suffix="%"
            :disabled="!form.buyDayMarginEnabled"
            :error-messages="getValidationErrorMessage('buyDayMargin')"
          />
        </v-flex>

        <v-flex xs6>
          <v-checkbox
            v-model="form.sellDayMarginEnabled"
            :ripple="false"
            label="Day sell"
            color="primary"
            hide-details
            disabled
            @change="onPeriodMarginCheckboxChange($event, 'sellDayMargin')"
          />
          <v-text-field
            v-model="form.sellDayMargin"
            class="forex-currency-pair-add-modal__margin-field"
            type="number"
            label="Margin"
            suffix="%"
            :disabled="!form.sellDayMarginEnabled"
            :error-messages="getValidationErrorMessage('sellDayMargin')"
          />
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs6>
          <v-checkbox
            v-model="form.buyNightMarginEnabled"
            :ripple="false"
            label="Night buy"
            color="primary"
            hide-details
            disabled
            @change="onPeriodMarginCheckboxChange($event, 'buyNightMargin')"
          />
          <v-text-field
            v-model="form.buyNightMargin"
            class="forex-currency-pair-add-modal__margin-field"
            type="number"
            label="Margin"
            suffix="%"
            :disabled="!form.buyNightMarginEnabled"
            :error-messages="getValidationErrorMessage('buyNightMargin')"
          />
        </v-flex>

        <v-flex xs6>
          <v-checkbox
            v-model="form.sellNightMarginEnabled"
            :ripple="false"
            label="Night sell"
            color="primary"
            hide-details
            disabled
            @change="onPeriodMarginCheckboxChange($event, 'sellNightMargin')"
          />
          <v-text-field
            v-model="form.sellNightMargin"
            class="forex-currency-pair-add-modal__margin-field"
            type="number"
            label="Margin"
            suffix="%"
            :disabled="!form.sellNightMarginEnabled"
            :error-messages="getValidationErrorMessage('sellNightMargin')"
          />
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs6>
          <v-checkbox
            v-model="form.buyWeekendMarginEnabled"
            :ripple="false"
            label="Weekends buy"
            color="primary"
            hide-details
            disabled
            @change="onPeriodMarginCheckboxChange($event, 'buyWeekendMargin')"
          />
          <v-text-field
            v-model="form.buyWeekendMargin"
            class="forex-currency-pair-add-modal__margin-field"
            type="number"
            label="Margin"
            suffix="%"
            :disabled="!form.buyWeekendMarginEnabled"
            :error-messages="getValidationErrorMessage('buyWeekendMargin')"
          />
        </v-flex>

        <v-flex xs6>
          <v-checkbox
            v-model="form.sellWeekendMarginEnabled"
            :ripple="false"
            label="Weekends sell"
            color="primary"
            hide-details
            disabled
            @change="onPeriodMarginCheckboxChange($event, 'sellWeekendMargin')"
          />
          <v-text-field
            v-model="form.sellWeekendMargin"
            class="forex-currency-pair-add-modal__margin-field"
            type="number"
            label="Margin"
            suffix="%"
            :disabled="!form.sellWeekendMarginEnabled"
            :error-messages="getValidationErrorMessage('sellWeekendMargin')"
          />
        </v-flex>
      </v-layout>

      <error-alert :error="error" />

      <template slot="actions">
        <v-btn
          class="t-confirm-button"
          color="primary"
          medium
          flat
          :disabled="!isFormFilled || loading"
          @click="onConfirmButtonClick"
        >{{ confirmButtonText }}</v-btn>

        <v-btn
          class="t-cancel-button"
          color="primary"
          medium
          flat
          @click="onCloseButtonClick"
        >cancel</v-btn>
      </template>
    </template>
  </settings-modal>
</template>

<script>
  // Utils
  import { currencyPairFormDataToRequestData, currencyPairToFormData } from '@/utils/Forex'

  // Events
  import { EVENT_FOREX_CURRENCY_PAIR_CHANGE } from '@/events/forexCurrencyPairs'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PageableApiRequest from '@/services/ApiRequests/PageableApiRequest'
  import ForexCurrencyRatesApi from '@/services/Api/ForexCurrencyRatesApi'
  import ProfileApi from '@/services/Api/ProfileApi'

  // Models
  import ForexCurrencyPair from '@/models/ForexCurrencyPair'

  // Mixins
  import form from '@/mixins/form'
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import DataHeading from '@/components/ui/Data/DataHeading'
  import DataRow from '../ui/Data/DataRow'
  import DataLabel from '@/components/ui/Data/DataLabel'
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'
  import ForexCurrencyPairCurrencies from '@/components/forex/ForexCurrencyPairCurrencies'

  export default {
    name: 'ProfileForexCurrencyPairEditorModal',
    components: {
      SettingsModal,
      ErrorAlert,
      DataHeading,
      DataRow,
      DataLabel,
      OneDataColumn,
      ForexCurrencyPairCurrencies
    },
    mixins: [form, modal, flashMessages],
    data () {
      return {
        selectedCurrencyPair: null,
        form: {
          fromCurrency: null,
          toCurrency: null,
          buyRate: null,
          buyDayMargin: null,
          buyDayMarginEnabled: false,
          buyNightMargin: null,
          buyNightMarginEnabled: false,
          buyWeekendMargin: null,
          buyWeekendMarginEnabled: false,
          buyFee: false,
          buyEnabled: true,
          sellRate: null,
          sellDayMargin: null,
          sellDayMarginEnabled: false,
          sellNightMargin: null,
          sellNightMarginEnabled: false,
          sellWeekendMargin: null,
          sellWeekendMarginEnabled: false,
          sellFee: false,
          sellEnabled: true
        },
        currencyPairsApiRequest: new PageableApiRequest(ForexCurrencyRatesApi.fetchAllPairs, ForexCurrencyPair),
        saveCurrencyPairApiRequest: new ApiRequest(ProfileApi.saveForexCurrencyPair)
      }
    },
    computed: {
      oneDataFirstColumnProps () {
        return {
          labelProps: { style: 'width: 92px; padding: 9px 2px 9px 15px' },
          dataProps: { style: 'min-width: auto; padding: 9px 6px 9px 2px' }
        }
      },
      oneDataSecondColumnProps () {
        return {
          labelProps: { style: 'width: 83px; padding: 9px 2px 9px 6px' },
          dataProps: { style: 'min-width: auto; padding: 9px 15px 9px 2px' }
        }
      },
      currencyPairs () {
        return this.currencyPairsApiRequest.data || []
      },
      title () {
        return `${this.modalData.currencyPair != null ? 'Edit' : 'Add'} currency pair`
      },
      confirmButtonText () {
        return this.modalData.currencyPair != null ? 'save changes' : 'add currency pair'
      },
      requiredFields () {
        const requiredFields = []

        if (this.form.buyDayMarginEnabled) {
          requiredFields.push('buyDayMargin')
        }

        if (this.form.buyNightMarginEnabled) {
          requiredFields.push('buyNightMargin')
        }

        if (this.form.buyWeekendMarginEnabled) {
          requiredFields.push('buyWeekendMargin')
        }

        if (this.form.sellDayMarginEnabled) {
          requiredFields.push('sellDayMargin')
        }

        if (this.form.sellNightMarginEnabled) {
          requiredFields.push('sellNightMargin')
        }

        if (this.form.sellWeekendMarginEnabled) {
          requiredFields.push('sellWeekendMargin')
        }

        return requiredFields
      },
      error () {
        return this.saveCurrencyPairApiRequest.error
      },
      loading () {
        return this.saveCurrencyPairApiRequest.loading
      }
    },
    watch: {
      selectedCurrencyPair (currencyPair) {
        this.setFormData(currencyPairToFormData(currencyPair))
      }
    },
    created () {
      if (this.modalData.currencyPair != null) {
        this.setSelectedCurrencyPair(this.modalData.currencyPair)
      } else {
        this.currencyPairsApiRequest.execute({ page: 0, size: 100 })
          .catch(() => [])
      }
    },
    methods: {
      formatCurrencyPairSelectItemValue (value) {
        return `${value.fromCurrency}-${value.toCurrency}`
      },
      formatBooleanValue (booleanValue) {
        return booleanValue === true ? 'Enabled' : 'Disabled'
      },
      setSelectedCurrencyPair (selectedCurrencyPair) {
        this.$set(this, 'selectedCurrencyPair', selectedCurrencyPair)
      },
      onPeriodMarginCheckboxChange (checkboxValue, field) {
        if (checkboxValue === false) {
          this.setFieldValue(field, null)
        }
      },
      onConfirmButtonClick () {
        this.saveCurrencyPairApiRequest
          .execute(this.modalData.profileId, currencyPairFormDataToRequestData(this.parsedFormInput))
          .then(() => {
            this.$eventHub.$emit(EVENT_FOREX_CURRENCY_PAIR_CHANGE)

            this.showSuccessFlashMessage(
              this.modalData.currencyPair != null
                ? 'Currency pair has been successfully edited.'
                : 'Currency pair has been successfully added.'
            )
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      }
    }
  }
</script>

<style lang="scss">
  .profile-forex-currency-pair-editor-modal {
    &__fee {
      margin: 0 0 2px 32px;
    }

    &__margin-field {
      margin-left: 32px;
    }
  }
</style>
